function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
import typography from '../../utils/typography';
var useStyles = () => {
  var theme = useTheme();
  return React.useMemo(() => {
    var isHC = theme.mode === 'contrast';
    var interactionColors = (state, color) => {
      var hcDefinitions = {
        backgroundColor: theme.palette.primary[state],
        color: theme.palette.foreground.inverse
      };
      return {
        ["&:".concat(state)]: _objectSpread({
          backgroundColor: theme.palette.neutral[color],
          color: theme.palette.foreground.default
        }, isHC && hcDefinitions)
      };
    };
    var optionColor = () => {
      if (isHC) {
        return theme.palette.primary.default;
      }
      return theme.palette.foreground.default;
    };
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      alignItems: 'center',
      borderRadius: theme.borderRadius3,
      boxSizing: 'border-box',
      color: optionColor(),
      cursor: 'pointer',
      display: 'flex'
    }, typography(theme).label), {}, {
      minHeight: "calc(".concat(theme.layout.size8, " + ").concat(theme.layout.size2, ")"),
      padding: "6px ".concat(theme.layout.size2),
      pointerEvents: 'auto',
      position: 'relative',
      textDecoration: 'none',
      transition: 'background-color 100ms linear, color 100ms linear',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: 'transparent'
    }, interactionColors('hover', 'backgroundLight')), interactionColors('active', 'background')), {}, {
      '&[aria-selected="true"]': {
        backgroundColor: theme.palette.primary.default,
        color: theme.palette.foreground.inverse,
        '&:hover': {
          backgroundColor: theme.palette.primary.hover,
          color: theme.palette.foreground.inverse
        },
        '&:active': {
          backgroundColor: theme.palette.primary.active,
          color: theme.palette.foreground.inverse
        }
      },
      '&:not(:last-of-type)': {
        marginBottom: theme.layout.size1
      },
      '> svg': {
        fill: theme.palette.foreground.default,
        marginRight: '6px',
        padding: 0
      }
    }, highContrastMediaQuery(theme));
  }, [theme]);
};
export default useStyles;